import { Flex, Switch } from 'antd';
import { useTranslation } from 'react-i18next';

type Props = {
  value?: boolean;
  onChange?: (value: boolean) => void;
};

export const HideToTeachersSwitch: React.FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation('ChatTranslations');

  return (
    <Flex align="center" gap={8}>
      <Switch checked={value} onChange={onChange} />
      <div>{t('HIDE_TO_TEACHER')}</div>
    </Flex>
  );
};
